import { render } from "./BoatForm.vue?vue&type=template&id=0e0d8720&scoped=true"
import script from "./BoatForm.vue?vue&type=script&lang=js"
export * from "./BoatForm.vue?vue&type=script&lang=js"

import "./BoatForm.vue?vue&type=style&index=0&id=0e0d8720&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e0d8720"

export default script